/**
 * BW19 PR-B — photo capture helpers.
 *
 * The capture file input uses `accept="image/*" capture="environment"` so iOS
 * Safari opens the rear camera and Android offers the camera-or-gallery
 * picker. Both produce a File which we forward as-is to the Worker; the
 * Anthropic vision API normalizes orientation and downsamples internally.
 *
 * We do enforce a client-side cap to give immediate feedback and avoid
 * uploading a 50MB ProRAW image.
 */

const MAX_BYTES = 20 * 1024 * 1024;

export function validatePhoto(file: File): { ok: true } | { ok: false; reason: string } {
  if (file.size === 0) return { ok: false, reason: "Photo is empty." };
  if (file.size > MAX_BYTES) {
    return {
      ok: false,
      reason: `Photo is ${(file.size / 1024 / 1024).toFixed(1)}MB, max is 20MB.`,
    };
  }
  if (!file.type.startsWith("image/")) {
    return { ok: false, reason: "File is not an image." };
  }
  return { ok: true };
}
